export default {
    ink: "#333333",
    white: "#ffffff",
    underlaymentGray: "#f5f5f5",
    blizzardGray: "#ebebeb",
    smoke: "#e0e0e0",
    silver: "#d6d6d6",
    platinum: "#cccccc",
    cement: "#c2c2c2",
    darkDray: "#999999",
    sky: "#0a99d5",
    skyHover: "#53c7f7",
    skySelected: "#15b1f4",
    night: "#485865",
    nightHover: "#698093",
    nightSelected: "#333e48",
    attentionYellow: "#fcb414",
    metricOrange: "#fc9014",
    cautionRed: "#ee3123",
    goodGreen: "#61bb46",
    marketingPurple: "#673ab7",
    azure: "#00aaff",
    azureHover: "#31c3ff",
    azureSelected: "#009deb",
    denim: "#242c33",
    denimHover: "#3c4a55",
    denimSelected: "#1d2228",
    pumpkin: "#dd8139",
    rosey: "#ff3232",
    treeFrog: "#30d763",
    butter: "#ffd600",
    amethyst: "#a06aff",
    deleteUndo: "#ff6565",
};
